import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FaTeeth,
  FaSmile,
  FaChild,
  FaTooth,
  FaUserMd,
  FaRegGrinStars,
  FaRegHospital,
  FaStar,
  FaRegSun,
} from "react-icons/fa";
import { useInView } from "react-intersection-observer";
import "./ServicesStyle.css";

const iconList = [
  FaChild,
  FaSmile,
  FaUserMd,
  FaTooth,
  FaTeeth,
  FaRegGrinStars,
  FaStar,
  FaRegHospital,
  FaRegSun,
  FaTeeth,
  FaSmile,
  FaUserMd,
];

const serviceKeys = [
  "pediatric",
  "orthodontics",
  "prosthodontics",
  "endodontics",
  "periodontics",
  "surgery",
  "cosmetic",
  "implants",
  "restorative",
  "preventive",
  "laser",
  "emergency",
];

const Services = ({ id }) => {
  const { t, i18n } = useTranslation();
  const { ref } = useInView({ triggerOnce: true, threshold: 0.3 });

  const [showAll, setShowAll] = useState(false);
  const visibleServices = showAll ? serviceKeys : serviceKeys.slice(0, 10);

  return (
    <section
      ref={ref}
      className={`services-section ${
        i18n.language === "ar" ? "rtl-layout" : ""
      }`}
      id={id}
    >
      <div className="services-container">
        <h4 className="services-subheading">{t("services.subheading")}</h4>
        <h2 className="services-title">{t("services.mainTitle")}</h2>
        <p className="services-subtitle">{t("services.subtitle")}</p>

        <div className="services-grid">
          {visibleServices.map((key, index) => {
            const Icon = iconList[index % iconList.length];
            return (
              <div className="service-card" key={key}>
                <div className="service-icon">
                  <Icon />
                </div>
                <h3 className="service-name">
                  {t(`appointment.service.${key}`)}
                </h3>
                <p className="service-description">
                  {t(`services.${key}.description`)}
                </p>
              </div>
            );
          })}
        </div>

        <div className="show-more-container">
          <button
            className="form-button service"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? t("services.showLess") : t("services.showMore")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
